/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionCheckboxBlankCircle: {
  name: 'temp-selection-checkbox-blank-circle';
  data: string;
} = {
  name: 'temp-selection-checkbox-blank-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z" fill="currentColor"/></svg>`,
};
